import UserAccessGroupsModal from './UserAccessGroupsModal';

export default UserAccessGroupsModal;
